import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getAllEmployeeWithHolidayPayslipRange } from "../../../actions/PaySlipAction";
import Rendertable from "./Rendertable";
import moment from "moment";

const EmployeeAttendanceList = ({
  getAllEmployeeWithHolidayPayslipRange,

  employeePaysliplist,
  employeeSalarylist,
  employeeDetails,
  employee,
  from,
  to,
  data,
  setData,
  reload,
  setReload,
  loading,
  setLoading,
  componentRef,
}) => {


  useEffect(() => {
    setLoading(true);
    getAllEmployeeWithHolidayPayslipRange(from, from).then(e => {
      console.log(e)
      setData(e)
      setLoading(false);
    });
  }, [reload]);

  return (
    <>
      <div ref={componentRef}>
        <table style={{ width: "100%", }}>
          <tr >
            <td style={{ width: "100%", padding: "10px" }}>
              <h3>ফেমাস ডিজাইন লিঃ</h3>
              <p>২৪৬/১/এফ পশ্চিম আগারগাঁও শের-ই-বাংলা নগর, ঢাকা-১২০৭ ।</p>
              <p>স্টাফ হলিডে এলাউন্স প্রদানের তালিকা</p>
              <p>মাসের নাম ও বছর : {moment(from).format("MMMM,  YYYY")}</p>
            </td>
          </tr>
        </table>
        {
          <Rendertable
            List={data}
            from={from}
            employee={employee}
            reload={reload}
            setReload={setReload}
          />
        }
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    employeeSalarylist: state.employeePayslip.employeePayslipdetails,
    employeePaysliplist: state.employeePayslip.employeePaysliplist,
  };
};

export default connect(mapStateToProps, {
  getAllEmployeeWithHolidayPayslipRange,
})(EmployeeAttendanceList);
